import { useLanguage } from "@/lib/translation";
import { dateFnsLocaleFor, intlLocaleFor } from "@/lib/locale";

/**
 * Locales for the active language, re-rendering on change.
 * `intlLocale(englishLocale)` for Intl / toLocale* calls (pass the locale the call site
 * used before, e.g. "en-GB", so English stays identical); `dateFnsLocale` for
 * date-fns `format(date, pattern, { locale: dateFnsLocale })`.
 */
export function useLocale() {
  const language = useLanguage();
  return {
    language,
    intlLocale: (englishLocale: string | undefined) =>
      intlLocaleFor(language, englishLocale),
    dateFnsLocale: dateFnsLocaleFor(language),
  };
}
